<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <!-- 按帐号查询 -->
            <el-tab-pane>
                <span slot="label">{{ $t("logs.proxy1") }}</span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <!-- 是否启用WEB代理 -->

                                <td>{{ $t("logs.proxy2") }}:</td>
                                <td>
                                    <el-checkbox-group v-model="enable_nginx_web">
                                        <el-checkbox label=""></el-checkbox>
                                    </el-checkbox-group>
                                </td>
                            </tr>
                            <tr>
                                <!-- WEB代理本地端口 -->

                                <td>{{ $t("logs.proxy3") }}:</td>
                                <td>
                                    <el-input v-model="nginx_web_useport" placeholder=""></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- WEB代理本地端口 -->

                                <td>{{ $t("logs.proxy4") }}:</td>
                                <td>
                                    <el-input v-model="nginx_web_address" placeholder=""></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- 是否启用POP代理 -->

                                <td>{{ $t("logs.proxy5") }}:</td>
                                <td>
                                    <el-checkbox-group v-model="enable_nginx_pop">
                                        <el-checkbox label=""></el-checkbox>
                                    </el-checkbox-group>
                                </td>
                            </tr>
                            <tr>
                                <!-- POP代理本地端口 -->

                                <td>{{ $t("logs.proxy6") }}:</td>
                                <td>
                                    <el-input v-model="nginx_pop_useport" placeholder=""></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- POP代理目标端口 -->

                                <td>{{ $t("logs.proxy7") }}:</td>
                                <td>
                                    <el-input v-model="nginx_pop_sport" placeholder=""></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- POP服务器地址 -->

                                <td>{{ $t("logs.proxy8") }}:</td>
                                <td>
                                    <el-input v-model="nginx_pop_address" placeholder=""></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- 是否启用IMAP代理 -->

                                <td>{{ $t("logs.proxy9") }}:</td>
                                <td>
                                    <el-checkbox-group v-model="enable_nginx_imap">
                                        <el-checkbox label=""></el-checkbox>
                                    </el-checkbox-group>
                                </td>
                            </tr>
                            <tr>
                                <!-- IMAP代理本地端口 -->

                                <td>{{ $t("logs.proxy10") }}:</td>
                                <td>
                                    <el-input v-model="nginx_imap_useport" placeholder=""></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- IMAP代理目标端口 -->

                                <td>{{ $t("logs.proxy11") }}:</td>
                                <td>
                                    <el-input v-model="nginx_imap_sport" placeholder=""></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- IMAP服务器地址 -->

                                <td>{{ $t("logs.proxy12") }}:</td>
                                <td>
                                    <el-input v-model="nginx_imap_address" placeholder=""></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="tanSend()">{{$t('logs.save_a')}}</el-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            nginx_imap_address: '',
            nginx_imap_sport: '',
            nginx_imap_useport: '',
            enable_nginx_imap: '',
            nginx_pop_address: '',
            nginx_pop_sport: '',
            nginx_pop_useport: '',
            enable_nginx_pop: '',
            nginx_web_address: '',
            nginx_web_useport: '',
            enable_nginx_web: '',
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44",
            }, ],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS",
                },
                {
                    value: "选项2",
                    label: "增加信头标记",
                },
                {
                    value: "选项3",
                    label: "强制TLS",
                },
            ],
            checked: "",
            fileList: [],
            radio: [],
        };
    },
    mounted() {
        this.getFileList1()
    },
    methods: {
        save_gray() {

            // this.loading = true;
            // this.tanchu = false
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_snmp_param",
                sid: sid,
                // byad: this.byad == true ? 1 : 0,

                community: this.community,
                ip_source: this.ip_source,

                data_loadok: this.data_loadok1

            });
            this.$axios
                .post("/api/adm/cgi/aspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList1();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
                

        },
        // 过滤单元加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/aspam.cgi", {
                    params: {
                        __mode: "load_nginx_param",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                    if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    }else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
             this.loading = false;

                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
             this.loading = false;

                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.data_loadok1 = res.data.ret.ok
                        this.community = res.data.ret.result.community

                        this.ip_source = res.data.ret.result.source

                    }
                })
                
        },
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
    },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

/deep/ .el-tabs__nav {
    padding-left: 14px;
}
</style>
